export default "<span class=\"j-duration\">0:00 / 0:00</span>\n"